import { api } from '../../../../../lib';
import { PRICING_PERMISSION_CONFIG_URL } from './constants';
import { CadastrosContractUser, PermittedUser, PriceApplicationConfig, PricingPermissionConfigResponse } from './types';
import { buildPriceApplicationRequest, normalizePriceApplicationConfig, sortUsersByName } from './utils';

const getClientId = () => JSON.parse(localStorage.getItem('cliente') ?? '{}')?.codigo;

export const getPriceApplicationConfig = async (): Promise<PriceApplicationConfig> => {
  const response = await api.get<PricingPermissionConfigResponse>(PRICING_PERMISSION_CONFIG_URL, {
    expectToken: true,
  });

  return normalizePriceApplicationConfig(response.data);
};

export const savePriceApplicationConfig = async (config: PriceApplicationConfig): Promise<PriceApplicationConfig> => {
  const response = await api.post<PricingPermissionConfigResponse>(PRICING_PERMISSION_CONFIG_URL, buildPriceApplicationRequest(config), {
    expectToken: true,
  });

  return normalizePriceApplicationConfig(response.data);
};

export const getContractUsers = async (): Promise<PermittedUser[]> => {
  const response = await api.get<CadastrosContractUser[]>(`${process.env.REACT_APP_CADASTROS_API_URL}/contratos/usuarioServicos`, {
    expectToken: true,
    params: {
      cliente: getClientId(),
      query: '',
      incluirAdministradores: true,
    },
  });

  return sortUsersByName(
    response.data.map(item => ({
      cd_usuario: item.usuario.codigo,
      user_name: item.usuario.nome,
      user_email: item.usuario.login,
    })),
  );
};
